import React from 'react'

function TenderTextMDC() {
  return (
    <embed src="\pdfs\EA3.8_desiccant-dehumidifier-mdc_2015-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextMDC